import React from 'react';
import { StyledText, DynamicButton } from "../../../../components/common/basic";

const TriviaRedemptionStatus = ({
  title = "Redemption Successful",
  background,
  history,
  label = "View Orders",
  onActionClick
}) => {
  const token = JSON.parse(localStorage.getItem("token"));

  return (
    <div style={{ textAlign: 'center', paddingTop: '20px' }}>
      <StyledText
        style={{ fontFamily: 'MTNMedium', marginBottom: '40px' }}
        size={21}>{title}</StyledText>
      <div>
        <DynamicButton
          onClick={onActionClick ? onActionClick : () => history.push('/trivia/order_details')}
          label={label}
          color={background}
          variant="outlined"
        />
      </div>
      <div>
        <DynamicButton
          onClick={() => history.push(`/home?token=${token}`)}
          label="Go Home"
          color={background}
        />
      </div>
    </div>
  )
}

export default TriviaRedemptionStatus;